import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../../styles";

const states = {
  activo: "success",
  suspendido: "warning",
  inactivo: "secondary",
};

export default function TableComponent({ data, currentPage, totalPages, onPreviousPage, onNextPage, onClick, accumulatedItems, totalItems, isSearch, onOpen }) {
  const classes = useStyles();

  if (data == null || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root} >
            <TableCell size='small' >NOMBRE</TableCell>
            <TableCell size='small' padding='none'>TIPO DE MEMBRECÍA</TableCell>
            <TableCell size='small' padding='none'>ESTADO</TableCell>
            <TableCell size='small' padding='none' style={{ textAlign: 'center' }}>ENTRAR</TableCell>
            {/*{keys.map(key => (
            <TableCell key={key}>{key}</TableCell>
          ))}*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, name, lastName, membershipType, partnerStatus }) => (
            <TableRow key={id} className={classes.rowTableHover}>
              <TableCell size='small' className={classes.tableTextStyle}
                onClick={onClick(id)}
              >{name + " " + lastName}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle}
                onClick={onClick(id)}
              >{membershipType}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle}
                onClick={onClick(id)}
              >
                <Chip label={partnerStatus} classes={{ root: classes[states[partnerStatus.toLowerCase()]] }} />
              </TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle}>
                {partnerStatus == "Activo" ? (
                  <>
                    <div className={classes.divActionButton} style={{ margin: 'auto' }}>
                      <Icons.DirectionsRun className={classes.iconAcctionInventory}
                        onClick={onOpen(id)}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isSearch != null && isSearch ? (
        <></>
      ) : (
        <>
          <div className={classes.footerTablePartner}>
            <div className={classes.footerTableFirstDiv}>
              <p className={classes.footerText}>TOTAL: {accumulatedItems} DE {totalItems}</p>
            </div>

            <div className={classes.footerTableSecondDiv}>
              <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
              <div className={currentPage <= 1 ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowBackIos className={currentPage <= 1 ?
                  classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
                  onClick={currentPage <= 1 ? null : onPreviousPage}
                />
              </div>
              <div className={classes.spaceBetweenButtons}></div>
              <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowForwardIos className={currentPage == totalPages ?
                  classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
                  onClick={currentPage == totalPages ? null : onNextPage}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
